import React from "react";
import Tooltip from "@mui/material/Tooltip";
import RefreshIcon from "../../images/refreshNew.svg";
import CopyImage from "../../images/CopyImage.svg";
import { getStatusIcon } from "../../Uitls/Util";
import { getOrDash, hasRealValue, joinSizes } from "../../Uitls/DetailsHelpers";
import Row from "./DetailsRow";
import { ToastContainer, toast } from "react-toastify";

function SourceBannerInformationTab({ bannerDetails = {}, onRefreshMLR }) {
  const isCopied = !!bannerDetails?.isCopied;
  if (!isCopied) {
    return (
      <div className="tab-pane-wrap">
        <Row label="Banner Copied:" value="No" />
      </div>
    );
  }

  const sizes =
    joinSizes(bannerDetails?.sourceSizes) ||
    (bannerDetails?.width && bannerDetails?.height
      ? `${bannerDetails.width}×${bannerDetails.height}`
      : "-");
  const sourceBannerId = bannerDetails?.sourceAssetId;
  const linkToBanner = sourceBannerId
    ? `${window.location.origin}/banner-editor/${sourceBannerId}`
    : null;

  const rawSourceDocId =
    bannerDetails?.sourceVeevaDocNumber || bannerDetails?.veevaDocNumber;
  const hasSourceDocId = hasRealValue(rawSourceDocId);
  const sourceDocId = hasSourceDocId ? rawSourceDocId : null;

  const sourceReviewStatus =
    bannerDetails?.sourceReviewStatus || "Not Submitted";
  const copyLinkToClipboard=(textToCopy)=> {
    (async () => {
      try {
        await navigator.clipboard.writeText(textToCopy);
        toast.success(
          <div className="notificationText">
            Successfully copied the link
          </div>
        );
      } catch (err) {
        toast.error(
          <div className="notificationText">
            Failed to copy — please try again
          </div>
        );
      }
    })();
  }
  return (
    <div className="tab-pane-wrap">
      <Row label="Banner Copied:" value="Yes" />
      <div className="kv-row">
        <div className="kv-label">PromoMats Doc ID:</div>
        <div className="kv-value kv-docid">
          {hasSourceDocId ? (
            <>
              <Tooltip title={sourceReviewStatus}>
                <img
                  src={getStatusIcon(sourceReviewStatus)}
                  alt="Status Icon"
                  className="status-icon-doc"
                  width={12}
                  height={12}
                />
              </Tooltip>

              <span className="doc-link">{getOrDash(sourceDocId)}</span>

              <img
                src={RefreshIcon}
                alt=""
                className="refreshIcondetails"
                onClick={() => onRefreshMLR(sourceDocId, "sourceReviewStatus")}
                title="Refresh"
              />
            </>
          ) : (
            <span>{getOrDash(null)}</span>
          )}
        </div>
      </div>

      <Row
        label="Name:"
        value={getOrDash(
          bannerDetails?.sourceAssetName || bannerDetails?.assetName
        )}
      />
      <Row
        label="Type:"
        value={
          (bannerDetails?.sourceIsAnimated ?? bannerDetails?.isAnimated) ===
          true
            ? "Animated"
            : "Static"
        }
      />
      <Row label="Size:" value={sizes} />
      <Row
        label="Product:"
        value={getOrDash(
          bannerDetails?.sourceBrandName || bannerDetails?.brandName
        )}
      />
      <Row
        label="Country:"
        value={getOrDash(
          bannerDetails?.sourceMarketName || bannerDetails?.marketName
        )}
      />

      <div className="kv-row">
        <div className="kv-label">Link:</div>
        <div className="kv-value kv-link d-flex">
          {linkToBanner ? (
            <>
              <img
                src={CopyImage}
                alt=""
                className="icon-copy"
                title="Copy link"
                //onClick={() => navigator.clipboard.writeText(linkToBanner)}
                onClick={(e)=>copyLinkToClipboard(linkToBanner)}

              />
              <Tooltip title={linkToBanner} placement="top">
                <a href={linkToBanner} target="_blank" rel="noreferrer">
                  {linkToBanner}
                </a>
              </Tooltip>
            </>
          ) : (
            <span>{getOrDash(null)}</span>
          )}
        </div>
      </div>
    </div>
  );
}

export default SourceBannerInformationTab;
